import React from 'react'
import classNames from 'classnames'

interface ButtonProps {
	icon: string
	disabled?: boolean
	busy?: boolean
	square?: boolean
	onClick: () => void
}

const Button: React.FC<ButtonProps> = props => (
	<button onClick={props.onClick} className={classNames('button', 'button--full-width', 'button--secondary', {
		'button--disabled': props.disabled,
		'button--busy': props.busy,
		'button--center-title': props.busy,
		'button--square': props.square,
	})}>
		<div className="button__content">
			<i className={classNames(props.icon, 'button__icon')} aria-hidden="true"/>
			<div className="button__title">{props.children} {props.busy !== true && <i className="far fa-arrow-right button__arrow" aria-hidden="true"/>}</div>
		</div>
	</button>
)

export default Button
